import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from '../../appTheme';

export const createPaymentStyle = StyleSheet.create({
    headerView: {
        alignItems: "center",
        flexDirection: "row",
        alignSelf: "flex-end",
        marginHorizontal: 15,
        marginTop: 10,
        marginBottom: 15,
    },
    innerScrollViewStyle: {
        marginHorizontal: 15,
        backgroundColor: appColors?.light,
        borderRadius: 10,
    },
    contentHeader: {
        marginHorizontal: 10,
        marginBottom: 10,
        marginTop: 10
    },
    firstContentView: {
        flexDirection: "row",
        alignItems: "flex-start",
        flexWrap: "wrap",
        marginTop: 10
    },
    dropdownOuterView: {
        marginHorizontal: 15,
        marginBottom: 25
    },
    dropdownLabelStyle: {
        paddingHorizontal: 15,
        paddingBottom: 5
    },
    paymentInputField: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    uploadFileContainer: {
        alignSelf: "flex-start",
        marginTop: 5,
        marginBottom: 20,
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        justifyContent: "center",
        height: 50,
        borderRadius: 5,
        flexDirection: "row",
        alignItems: "center"
    },
    vendorListOuterView: {
        margin: 10,
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        borderRadius: 5,
        padding: 10
    },
    firstView: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingHorizontal: 5,
        // padding:5
    },
    contentView: {
        flexDirection: "row",
        alignItems: "center"
    },
    secondView: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: 5
    },
    badgeTextStyle: {
        fontFamily: appFonts?.bold,
        color: appColors?.primary,
        fontSize: fontSize?.smallerFontSize
    },
    dividerStyle: {
        marginVertical: 10,
        marginHorizontal: 5
    }

})